import _ from 'lodash';
import { Avatar } from '@material-ui/core';
import { StyledAssigneeList, StyledAssigneeRow } from './AssigneeList.style';

const TOP_ASIGNEES_ON_VIEW = 4;

const AssigneeList = ({ pointData, resourceType }) => {
  const topAssignees = _.get(pointData, 'assignees.top_assignees', []).slice(
    0,
    TOP_ASIGNEES_ON_VIEW
  );
  const totalAssignees = _.get(pointData, 'assignees.total', 'N/A');

  return (
    <StyledAssigneeList>
      <div className='header'>
        Top {topAssignees.length} of {totalAssignees} people work on this{' '}
        {resourceType.singleName}
      </div>
      <div className='main'>
        {topAssignees.map((assignee, idx) => {
          const name = _.get(assignee, 'assignee_name');
          const avatarUrl = _.get(assignee, 'assignee_avatar_url');

          return (
            <StyledAssigneeRow key={idx}>
              <Avatar src={avatarUrl} />
              <div className='name'>{name}</div>
            </StyledAssigneeRow>
          );
        })}
      </div>
    </StyledAssigneeList>
  );
};

export default AssigneeList;
